export default "__VITE_ASSET__CiR3yc0q__"